// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AssessmentController from "./assessment_controller"
application.register("assessment", AssessmentController)

import CopyLinkController from "./copy_link_controller"
application.register("copy-link", CopyLinkController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
